<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-06 15:33:08
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-06-20 17:29:10
 * @FilePath: /content-center/src/components/wiki/SymptomsParts.vue
-->
<template>
  <div class="flex align-items-center department-item">
    <div class="content-item-label"><span v-if="JSON.parse(commonData[0].value)==='1'" class="red">*</span>{{JSON.parse(commonData[1].value)||'作用'}}</div>
    <el-select v-model="select" clearable placeholder="请选择作用">
      <el-option
        v-for="(item,index) in effects"
        :key="index"
        :label="item.desc"
        :value="item.code"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { request } from '@/utils/axios';

export default {
  name: "EffectSelected",
  props: ['contentChineseMedicine', 'commonData'],
  data() {
    return {
      effects: []
    }
  },
  created(){
    this.queryDictionaries()
  },
  computed: {
    select: {
      get() {
        return this.contentChineseMedicine
      },
      set(val) {
        console.log(val, 888);
        this.$emit('update:contentChineseMedicine',val)
      }
    }
  },
  methods: {
    // 获取症状部位
    async queryDictionaries() {
      try {
        await request('health_cmp_queryDictionaries',{
          tenantId: this.$commonJs.getTenantId(),
          typeList: JSON.parse(this.commonData[2].value),
        }).then(res => {
          this.effects = res
        });
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped lang="scss">
.department-item {
  font-size: 14px;
  color: #2c3443;
  margin-top: 20px;
  position: relative;
  width: 50%;

  .content-item-label {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;

    span {
      color: #f62458;
      margin-right: 5px;
    }
  }
}
</style>
